<template>
	<div class="business">
		<div class="relative box1">
			<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/php/bg3-pc.jpg':'https://qiniuimg.wurun.net/jtyw.jpg'" alt="">
			<div class="text">
				<div class="fs45 fw mt30 cor-27">集团业务</div>
				<div class="fs22 let-spc6 cor-27">注重社区生活品质的提升，致力于社区商业文明发展</div>
				<!-- <p class="ico"></p> -->
				<div class="cor-8f fs10 let-spc6">Weroom Group Business</div>
			</div>
		</div>
		<div class="relative">
			<div class="box2 flex align-items just-around relative">
				<div class="w1200 flex align-items just-center">
					<div v-for="(d,i) in tab" :key="i" class="fs16" :class="i == tabIdx?'cur':''" @click="submit(i)">
						{{d.name}}</div>
				</div>
			</div>
			<div class="box3" :class="init?'init':''" v-if="tabIdx == 0">
				<div class="w1200">
					<div class="fl">
						<div class="fs36 cor-8d mt30 fw tit"><svgIcon iconClass="wLogo" class="svg"/></div>
						<div class="line40 mt30 text fs16">
							<p>2006年，五润品牌创立于福建厦门，专注于轻⻝早餐连锁经营，为向往美好生活的人们提供了优质的早餐服务。五润以社区为起点，17年来扎根于社区，不止于企业、品牌自身的经营，更在社区环境、商业、文化赋能方面不断的探索 。打造更加舒适的⽤餐环境 , 营造时尚简便的⽤餐体验 , 构建起全新的社区生活方式。</p><br/>
							<p>作为精致生活引领者，五润也在不断自我升级与迭代，五润人带着“社区商业⽂化践行”的初心⽮志前行着。</p>
						</div>
					</div>
					<div class="fr">
						<img src="https://qiniuimg.wurun.net/news/1.jpg" alt="">
					</div>
				</div>
			</div>
			<div class="box4 relative" v-if="tabIdx == 0">
				<div class="bg"></div>
				<div class="w1200 box">
					<div class="tit fs36 relative text-c cor-27"><span>五大超品质标准</span></div>
					<div class="ul">
						<div class="li">
							<div class="child">
								<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/pz1.png':'https://qiniuimg.wurun.net/m-pz1.jpg'" alt="" mode="aspectFit">
								<div class="text">
									<div class="fs24 ml30 title">环境</div>
									<div class="text ov2">全新升级的终端门店在整体设计上力求温馨雅致，细节上匠心独具，为广大食客创造更加简雅的用餐环境。</div>
								</div>
							</div>
						</div>
						<div class="li">
							<div class="child">
								<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/f5.png':'https://qiniuimg.wurun.net/m-pz2.jpg'" alt="">
								<div class="text">
									<div class="fs24 ml30 title">格调</div>
									<div class="text ov2" style="align-items:baseline">以色香声味触的五感法全面打造五润的新格调，在视觉、听觉、味蕾、口味、细节等方面，为食客带来舒适的综合消费体验。</div>
								</div>
							</div>
							<div class="child">
								<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/pc/shicai6.jpg':'https://qiniuimg.wurun.net/news/sc1.jpg'" alt="">
								<div class="text">
									<div class="fs24 ml30 title">食材</div>
									<div class="text ov2">甄选健康无污染的绿色食材，保证食品的安全性；所有面食所用的面粉、大米等都是行业高标准；所取的肉类、蔬菜等一律选用新鲜食材；食材是基础，绝不马虎。</div>
								</div>
							</div>
						</div>
						<div class="li">
							<div class="child">
								<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/f2.png':'https://qiniuimg.wurun.net/m-pz4.jpg'" alt="">
								<div class="text">
									<div class="fs24 ml30 title">服务</div>
									<div class="text ov2">扎根社区，给食客带去家人般的服务，自然温馨不做作。</div>
								</div>
							</div>
							<div class="child">
								<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/f4.png':'https://qiniuimg.wurun.net/m-pz5.jpg'" alt="">
								<div class="text">
									<div class="fs24 ml30 title">工艺</div>
									<div class="text ov2">传承中华传统老面发酵的工艺，做地道的中华面点美食；由中央厨房原料配送确保品质稳定；各类烘焙产品均采用了市场上先进的烘焙技术，与时俱进，精益求精。</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="zox1 flex align-items just-between" v-if="tabIdx == 1">
				<div class="fl">
					<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/zuozi.jpg" alt="">
				</div>
				<div class="fr">
					<div>
						<div class="s">
							<svgIcon iconClass="zzi" class="svg"/>
							<svgIcon iconClass="zhuangshi" class="svg"/>
						</div>
						<span>
							佐籽落座于海上花园城市福建厦门<br/>
							致力于孵化精致烘焙、高端伴手礼、商务茶歇、西式糕点等<br/>
							多维美食体验<br/>
							秉持着“以味传心，以礼传情”的初衷<br/>
							提倡健康乐食主义<br/>
							创始人将过去17年的餐饮沉淀与磨练荟萃于此<br/>
							以匠心制良品之态度打造有别于市场上的西点礼品品牌
						</span>
					</div>
				</div>
			</div>
			<div class="zox2 relative" v-if="tabIdx == 1">
				<img src="https://qiniuimg.wurun.net/news/5.jpg" alt="" srcset="">
			</div>
			<div class="box7" v-if="tabIdx == 2">
				<!-- <img src="@/style/img/car.png" alt=""> -->
				<div class="logo w1200 ">
					<div class="fl"><img src="https://qiniuimg.wurun.net/news/2.jpg" alt=""></div>
					<div class="fr relative">
						<svgIcon iconClass="car" class="svg"/>
						<span>
							早餐是一天中最重要的开始，<br>
							也是串联一天快乐好心情的必备。<br>
							五润秉持“简单(SIMPLE)、快乐(FUN)、<br>
							成功(SUCCESS)”的品牌价值观<br>
							响应“厦门市早餐工程”，以绿色健康，丰富时尚的早餐为载体，<br>
							致力于带来趣味FUN享的全新生活方式，为快乐生活做+法。<br>
							并且，契合智能化时代的风潮，研发专属APP<br>
							串联一日三餐的丰盛便捷<br>
							带来不止于早餐的快乐+倍。<br>
							五润早餐FUN+，是以早餐为起点，<br>
							一日三餐智能便捷的加倍串联<br>
							五润早餐FUN+，是FUN趣生活的幸福起点<br>
							五润早餐FUN+让品质生活、FUN享体验，<br>
							自早餐启航，无限叠+。
						</span>
						<div class="ico">
							<img src="@/style/img/carIco.png" alt="">
							<div class="icoName">厦门市早餐工程</div>
							<div class="">承办单位</div>
						</div>
					</div>
					
				</div>
				<div class=" fs36 jiamen">
					<div class="w1200">
						<div class="fl">
							<div class="title ">项目背景</div>
							<div class="text">
								<p>
									在碎片化早餐市场 , 为什么便利店、早餐摊点、面包店渐渐成为主流？
								</p>
								<br/>
								<p>
									在快节奏都市生活中，你或许会发现，身边开始有越来越多的人通过便利店、早餐摊点、面包店解决自己一日三餐，一些口味好的便当或者卤煮都会吸引人们争相去购买。无论是网红销售，共享销售甚至是周边销售，都在无形的分割着正餐市场 。尤其是在商圈 、 写字楼，这个现象尤为明显。之所以能够分流本属于正餐企业的市场，核心在于它们能够快速解决消费者需求。
								</p><br/>
								<p>
									当需要快速解决刚性需求的时候，消费决策的第一因素是选择的便利性、简单性。
								</p>
							</div>
							<div class="active">
								项目即将开启加盟
								敬请期待！
							</div>
						</div>
						<div class="fr">
							<img src="https://qiniuimg.wurun.net/news/6.png" alt="" srcset="">
						</div>
					</div>
				</div>
			</div>
			<div class="box5 relative" v-if="tabIdx != 2">
				<div class="w1200 relative box">
					<div class="tit cor-27">
						<span>{{tabIdx == 0?'六大核心产品体系':tabIdx == 1?'核心产品体系':'餐车'}}</span>
					</div>
					<div class="flex align-items just-between list " v-if="tabIdx == 0">
						<div class="relative" v-for="(d,i) in box5" :key="i">
							<img :src="d.url" alt="" srcset="">
							<div class="fs24 fw cor-27">{{d.name}}</div>
							<div class="cor-f5 Ename">{{d.eName}}</div>
							<p></p>
							<div class="child" v-if="windowWidth > 820">
								<div class="fs18">{{d.name}}</div>
								<p></p>
								<span>{{d.text}}</span>
							</div>
						</div>
					</div>
					<div v-if="tabIdx == 1">
						<div class="flex align-items just-between zox3 w1200 ">
							<div v-for="(d,i) in zox3" :key="i">
								<img :src="d.url" alt="" class="mt30">
								<div class="fs18 fw">{{d.name}}</div>
								<div class="eName">{{d.eName}}</div>
								<p></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="box6 relative cor-f flex align-items" v-if="windowWidth > 820 && tabIdx == 0">
				<img src="@/style/img/bus_botBg.png" alt="">
			</div>
		</div>
		<rightTab v-if="windowWidth > 820"/>
	</div>
</template>

<script>
	require('../../style/css_w/business.css')
	import rightTab from "@/components/rightTab.vue"
	export default {
		name: 'Business',
		components: {
			rightTab
		},
		computed: {
			classOption () {
				return {
					step: 2, // 数值越大速度滚动越快
					limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 2, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		data() {
			return {
				windowWidth:'',
				tabIdx: 0,
				init:false,
				tab: [{
					name: '五润'
				}, {
					name: '佐籽'
				}, {
					name: '餐车'
				}],
				box5: [ {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2Ft.png',
					name: '蛊汤类',
					eName: 'Cup Soup',
					text: '选用新鲜肉品等纯天然食材长时间炖煮养生汤品，根据一年四季不同时节调整品类，让用餐的食客能够轻松享受靓汤滋补。'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2Fz.png',
					name: '粥类',
					eName: 'Porridge',
					text: '精心配比的粗粮谷物组合，每日新鲜熬煮，为食客提供暖心暖胃、均衡营养的粥品。'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2Fbz.png',
					name: '包子类',
					eName: 'Steamed Stuffed Bun',
					text: '以鲜肉大包为首，为保证包子面皮Q弹与馅料的鲜香口感，由央厨配送原料，手工包制、醒发、蒸煮。在口味与种类上，保留了中华传统风味时也开创西式风味，荤素咸甜多样化。'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2Fjc.png',
					name: '简餐类',
					eName: 'Simple Meal',
					text: '粥、饭、面、汤搭配的简餐供应，满足消费者的三餐能量所需，在口味与菜品上因地制宜，在简单的三餐中亦能品尝到美食带来的满足感。'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2Fdx.png',
					name: '点心类',
					eName: 'Dessert',
					text: '煎饺、肉粽、鲜肉烧饼、果蔬煎蛋等点心为食客提供丰富的选择，让早餐不再单一化，也在享用的过程中品尝生活滋味。'
				},{
					url: 'https://qiniuimg.wurun.net/f6.png',
					name: '烘焙类',
					eName: 'Baking',
					text: '烘焙产品由轻奢烘焙品牌佐籽专供优质产品，十几款当红产品不仅升级了五润的产品线，更为客人增添了多种口味的搭配选择。'
				}],
				boon: [{
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F1.jpg',
					name: '鲜虾抄手'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F2.jpg',
					name: '五润鲜肉包'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F3.jpg',
					name: '当归牛肉盅'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F4.jpg',
					name: '鸡肉芋头粥'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F5.jpg',
					name: '西葫芦水饺'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F1.jpg',
					name: '鲜虾抄手'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F2.jpg',
					name: '五润鲜肉包'
				}, {
					url: 'https://qiniuimg.wurun.net/wurun_pc%2F%E4%B8%9A%E5%8A%A1%2F3.jpg',
					name: '当归牛肉盅'
				}],
				zox4: [{
					url: 'https://qiniuimg.wurun.net/zz5.png',
					name: '鲜虾抄手'
				}, {
					url: 'https://qiniuimg.wurun.net/zz6.png',
					name: '日式海盐卷'
				}, {
					url: 'https://qiniuimg.wurun.net/zz7.png',
					name: '日式雪菜毛豆包'
				}, {
					url: 'https://qiniuimg.wurun.net/zz8.png',
					name: '肉松可颂'
				}, {
					url: 'https://qiniuimg.wurun.net/zz9.png',
					name: '丹麦培根'
				}],
				zox3: [ {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/zz1.png',
					name: '茶歇服务',
					eName: 'Tea Break',
					text: '精致茶歇定制服务'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/zz2.png',
					name: '节令伴手礼',
					eName: 'Souvenir',
					text: '亲朋佳节送礼解决方案'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/zz3.png',
					name: '西式糕点',
					eName: 'West Point',
					text: '企业下午茶解决方案'
				},{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/zz4.png',
					name: '烘焙面包',
					eName: 'Baking',
					text: '现场烘焙，新鲜出炉'
				}]
			}
		},
		created(){
			
		},
		mounted() {
			setTimeout(()=>{
				this.init = true
			},100)
			document.documentElement.scrollTop = 0
			if(this.$route.query.i){
				// this.tabIdx = this.$route.query.i
			}
			this.windowWidth  = document.body.clientWidth
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
	},
	methods: {
		submit(i) {
			this.tabIdx = i
		}
	}
	}
</script>

<style scoped>
</style>
